import { AuthState } from "store/authSlice";

export const isTokenValid = (state: AuthState): boolean => {
    const currentTime = Date.now();
    return !!state.token && !!state.tokenExpiration && currentTime < state.tokenExpiration;
  };